import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './compositionActionTypes';
import * as actions from './compositionActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getCompositionSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getCompositions, payload);
    yield put(actions.getCompositionDataAction(data));
  } catch (e) {
    yield put(actions.getCompositionErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createCompositionSaga(action) {
  try {
    console.log('createCompositionSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create composition API payload:', payload);
    
    const { data } = yield call(endpoints.createComposition, payload);
    console.log('Create composition API response:', data);
    
    yield put(actions.createCompositionDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/composition');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createCompositionSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createCompositionErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateCompositionSaga(action) {
  try {
    console.log('updateCompositionSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update composition API payload:', payload);
    
    const { data } = yield call(endpoints.updateComposition, payload);
    console.log('Update composition API response:', data);
    
    yield put(actions.updateCompositionDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getCompositionRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/composition');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateCompositionSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateCompositionErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteCompositionSaga(action) {
  try {
    console.log('deleteCompositionSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete composition API payload:', payload);
    
    const { data } = yield call(endpoints.deleteComposition, payload);
    console.log('Delete composition API response:', data);
    
    yield put(actions.deleteCompositionDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getCompositionRequestAction());
    }
    
  } catch (e) {
    console.error('deleteCompositionSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteCompositionErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* compositionSaga() {
  yield all([
    takeEvery(types.GET_COMPOSITION_REQUEST, getCompositionSaga),
    takeEvery(types.CREATE_COMPOSITION_REQUEST, createCompositionSaga),
    takeEvery(types.UPDATE_COMPOSITION_REQUEST, updateCompositionSaga),
    takeEvery(types.DELETE_COMPOSITION_REQUEST, deleteCompositionSaga),
  ]);
}
